// extracted by mini-css-extract-plugin
export default {"searchInput":"tarvjESXBP15Vk3Uy1uG","foodCardList":"KH4ucsrdAfxj7QziQ5xQ","loadMoreSentinel":"_FNXh3SiPCv9qv5YAEg_","emptyList":"z2ofC6_iu5rZoxbFRgOg"};